import {Component, Fragment, h} from 'preact';

class Warning extends Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			visible: true,
			title: props.title,
			content: props.content,
		}
	}

	close = () => {
		this.setState({
			visible: false,
		})
	}

	render(props, state, context) {
		const {title, content} = props;
		return (
			<Fragment>
			{
				this.state.visible && <div className="warning warning_dark page__warning page__warning_small">
						<div className="container warning__container warning__container_small">
							<div className="warning__inner">
								<span className="warning__icon"><svg width="24" height="24" viewBox="0 0 24 24"
																	 fill="none" xmlns="http://www.w3.org/2000/svg"><path
									d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="#FF7819"></path></svg>
								</span>
								<h3 className="warning__title">{title}</h3>

								<div className="warning__body" style="color: #fff;">
									{
										typeof content == 'object' && content.length > 0 && <ul className="warning__items">
											{
												content.map(item => (
													<li className="warning__item">{item}</li>
												))
											}
										</ul>
									}
									{
										typeof content == 'string' && content.length > 0 && {content}
									}
								</div>

								<button onClick={this.close} className="warning__close-button js__close-warning">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
										 xmlns="http://www.w3.org/2000/svg">
										<path
											d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
											fill="black"/>
									</svg>
								</button>

							</div>
						</div>
					</div>
			}
			</Fragment>
		);
	};

}

export default Warning;
